import { footerLinks } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-xl">
                黑
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-black text-xl text-foreground-950">黑料福利</span>
                <span className="text-xs text-foreground-600 mt-1 tracking-wide">社区话题 · 每日更新不断更</span>
              </span>
            </div>
            <p className="mt-5 text-sm text-foreground-700 leading-relaxed max-w-md">
              黑料福利每日整理当日热议话题，把散落的讨论聚成一条清晰的时间线。黑料福利今日更新、黑料福利最新新料同步上线，热闹由大家一起凑。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-play-circle-line', label: '视频号' },
                { icon: 'ri-rss-line', label: '订阅' },
              ].map((item) => (
                <button
                  key={item.label}
                  type="button"
                  aria-label={item.label}
                  className="cursor-pointer w-10 h-10 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 flex items-center justify-center hover:text-primary-600 hover:border-primary-300 transition-colors"
                >
                  <i className={`${item.icon} text-lg`}></i>
                </button>
              ))}
            </div>
          </div>

          {footerLinks.map((column) => (
            <div key={column.title} className="md:col-span-2">
              <h4 className="font-heading font-bold text-sm text-foreground-950">{column.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1"></div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs md:text-sm text-foreground-600 text-center sm:text-left">
            © 2026 黑料福利 · 内容为网友讨论整理，请理性围观，勿将讨论指向具体个人。
          </p>
          <div className="flex items-center gap-5">
            <a href="#top" className="cursor-pointer text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
              返回顶部
            </a>
            <a href="#trust" className="cursor-pointer text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
              内容说明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}